import React, {Component} from 'react';
import {getCurrentUserId, getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import Header from '../Header'
import Form from '../../common/Form'
import {Link} from "react-router-dom";
// import ReactGA from "react-ga";

class ChooseTeam extends Form {
    constructor(props) {
        super(props);

        this.state = {
            userTeams: [],
            userTeamsIn: [],
            loading: false,
            selectedTeamId: '',
            spinnerActive: false,
            unsuccessfulPostCall: false,
            errors: {},
            locationState: this.props.location.state && this.props.location.state.previous ? this.props.location.state.previous : ''
            //fromPathname: this.props.history.location.state.from.pathname
        };
    }

    schema = {};

    componentDidMount = async () => {
       // ReactGA.pageview(window.location.pathname + window.location.search);

        try {
            this.setState({
                loading: true
            });
            const result = await http.get('api/user/' + getCurrentUserId() + '/teams', {headers: {authorization: getJwt()}});
            let userTeams = result.data.teams.data;
            let userTeamsIn = result.data.teams_in.data;
            let selectedTeam;
            let teamsLength = userTeams.length
            // console.log('userTeams :', userTeams)
            // console.log('userTeamsLength: ', teamsLength)
            // console.log('last created team: ', userTeams[teamsLength - 1])
            //
            // console.log('referrer: ', this.state.locationState)
            //
            //     console.log('came from team members')
                selectedTeam = userTeams[teamsLength - 1].id

            // console.log('selected team id: ', selectedTeam)
            this.setState(
                {
                    userTeams,
                    userTeamsIn,
                    loading: false,
                    selectedTeamId: selectedTeam !== '' ? selectedTeam : userTeams.length === 1 ? userTeams[0].id : userTeamsIn.length === 1 ? userTeamsIn[0].id : ''
                }
            )

        } catch (e) {
            this.setState({
                loading: false
            })
            //should handle error here
        }
    };

    // componentDidUpdate = async () => {
    //     if (this.props.location.state && this.props.location.state.previous) {
    //         console.log('did update first if')
    //         if (this.state.locationState !== this.props.location.state.previous) {
    //             console.log('entered component did update')
    //             await this.setState({
    //                 locationState: this.props.location.state.previous
    //             })
    //         }
    //     }
    // }

    selectTeam = (id) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Choose a team - team selected',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        this.setState(
            {selectedTeamId: id}
        )
    };


    doSubmit = async (e) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Choose a team - Next',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        //creating a feed with name sent from Feed Name
        e.preventDefault()
        try {
            // console.log('feed name: ', localStorage.name);
            await this.setState({spinnerActive: true, unsuccessfulPostCall: false});
            const newFeedResult = await http.post('api/user/' + getCurrentUserId() + '/source', {name: localStorage.name}, {headers: {authorization: getJwt()}});

            await localStorage.setItem("feed_id", JSON.stringify(newFeedResult.data.id));
            await localStorage.setItem("source_clicked", JSON.stringify(newFeedResult.data.id));
            await this.props.selectSource(newFeedResult.data);

            // console.log('new feed: ', newFeedResult);
            try {
                const feedToTeam = await http.post('/api/user/' + getCurrentUserId() + '/team/feed/' + newFeedResult.data.id, {team_id: this.state.selectedTeamId}, {headers: {authorization: getJwt()}})
                // console.log('feed to team response: ', feedToTeam);
                this.props.updateUser(
                    {
                        sources: {
                            data: [
                                ...this.props.user.sources.data,
                                newFeedResult.data
                            ]
                        }
                    }
                )
                await this.props.appPropagateUserPlatforms([]);
                // this.props.history.push('/feed-source');
                await this.props.history.push('/subscription-plans');
                // console.log('feed id: ', newFeedResult.data.id);
            } catch (ex) {
                await this.setState({spinnerActive: false, unsuccessfulPostCall: true});
                if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors = ex.response.data.errors;
                    this.setState({errors});
                }
                if (ex.response && ex.response.status === 401) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors.email = ex.response.data.message;
                    this.setState({errors});
                }
            }


        } catch (ex) {
            this.setState({spinnerActive: false, unsuccessfulPostCall: true});
            if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                errors = ex.response.data.errors;
                this.setState({errors});
            }
            if (ex.response && ex.response.status === 401) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                errors.email = ex.response.data.message;
                this.setState({errors});
            }
        }
    };
    createNewTeam = () => {
        localStorage.setItem('navigateBackTo', '/choose-team')
        this.props.history.push('/create-team');
    };


    render() {
        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title distribution-title m-lg-b'>
                            <span>Choose a team for this workspace</span>
                        </h1>
                        <p className='m-m-b text-center grey-text'>
                            Choose an existing team
                        </p>

                        <form onSubmit={this.handleFormSubmit}>
                            <div id='teams'>
                                {
                                    this.state.loading ?
                                        <h3 className="text-dark-blue text-center">Loading teams...</h3>
                                        :
                                        <React.Fragment>
                                            {
                                                this.state.userTeams.map(team => {

                                                        return this.state.selectedTeamId.toString() === team.id.toString() ?

                                                            <p key={team.id} onClick={() => this.selectTeam(team.id)}
                                                               className='onboarding-team selected'>{team.team_name}
                                                            </p>

                                                            :

                                                            <p key={team.id} onClick={() => this.selectTeam(team.id)}
                                                               className='onboarding-team'>{team.team_name}
                                                            </p>
                                                    }
                                                )
                                            }
                                            {
                                                this.state.userTeamsIn.map(teamIn => {

                                                        return this.state.selectedTeamId.toString() === teamIn.id.toString() ?

                                                            <p key={teamIn.id} onClick={() => this.selectTeam(teamIn.id)}
                                                               className='onboarding-team selected'>{teamIn.team_name}
                                                            </p>

                                                            :

                                                            <p key={teamIn.id} onClick={() => this.selectTeam(teamIn.id)}
                                                               className='onboarding-team'>{teamIn.team_name}
                                                            </p>
                                                    }
                                                )
                                            }
                                        </React.Fragment>
                                }
                            </div>
                            {this.state.selectedTeamId ?
                                (
                                    this.state.spinnerActive ?

                                        <button disabled={true}
                                                className='btn-action btn-sm m-sm-b center'>Next <span
                                            className='fa fa-spin fa-spinner'></span>
                                        </button>
                                        :
                                        <button onClick={this.doSubmit}
                                                className='btn-action btn-sm m-sm-b center'>Next
                                        </button>

                                )
                                :
                                <button disabled={true} className='btn-action btn-sm m-sm-b center'>
                                    Next
                                </button>
                            }
                        </form>

                        <p className='grey-text text-center m-sm-b'><span className='or'>or</span></p>

                        <p onClick={this.createNewTeam} className='create-team onboarding-team create-team'>Create new
                            team</p>
                        <div className='panel-message text-center'>
                            <p>
                                <Link to="#" onClick={() => {
                                    this.props.history.push(localStorage.navigateBackTo ? localStorage.navigateBackTo : this.state.returnToScreen || '/dashboard')
                                    localStorage.removeItem('selectedTeam');
                                    localStorage.removeItem('navigateBackTo');
                                }}>Cancel</Link>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default ChooseTeam;